import { render, staticRenderFns } from "./RelatedPortfolio.vue?vue&type=template&id=2061c8a8&scoped=true&"
import script from "./RelatedPortfolio.vue?vue&type=script&lang=js&"
export * from "./RelatedPortfolio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2061c8a8",
  null
  
)

export default component.exports